var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgreementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1610_35109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.997 264.016H208.28V208.379H263.997V264.016Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.704 109.256C58.2222 110.065 56.7238 110.839 55.2087 111.578L0 56.4624V49.6314L59.704 109.256Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0964 104.88C65.7032 105.765 64.2934 106.627 62.8669 107.465L0 44.6888V37.881L67.0964 104.88Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8497 113.191C50.2793 113.91 48.689 114.599 47.0788 115.258L0 68.2471V61.4161L51.8497 113.191Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5754 94.9468C79.3395 95.9908 78.0836 97.0137 76.8078 98.0156L0 21.2955V14.4646L80.5754 94.9468Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9937 100.139C72.7091 101.088 71.4033 102.014 70.0766 102.916L0 32.9407V26.2523L73.9937 100.139Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7585 89.3312C85.6001 90.4525 84.4206 91.5518 83.2201 92.6289L0 9.52905V2.70135L86.7585 89.3312Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120.182L4.19286 124.368C2.80187 124.415 1.40428 124.439 0 124.441V120.182Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6782 119.562C32.9063 120.075 31.1111 120.55 29.2926 120.988L0.00537109 91.7434V84.9423L34.6782 119.562Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2371 121.89C23.35 122.277 21.4484 122.621 19.5325 122.922L0 103.421V96.6894L25.2371 121.89Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5138 116.642C41.8482 117.261 40.1647 117.847 38.4637 118.4L0 79.9923V73.1911L43.5138 116.642Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1835 123.521C13.1036 123.773 11.0105 123.975 8.90404 124.125L0 115.234V108.363L15.1835 123.521Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.458 38.7406C117.902 40.437 117.312 42.1146 116.687 43.7734L72.8643 0.013958H79.6752L118.458 38.7406Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.062 29.5879C120.623 31.3927 120.138 33.1776 119.623 34.9492L84.6216 0.00132751H91.4326L121.062 29.5879Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5336 83.3337C91.4571 84.5259 90.3574 85.6959 89.2344 86.8438L2.2666 -0.00167847H9.0942L92.5336 83.3337Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.278 14.4092C123.467 12.7794 123.623 11.1398 123.748 9.49023L114.758 0.513672H109.366L123.278 14.4092Z",
    fill: "#F7F9FA",
    stroke: "#D1DBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.065 3.43945C124.093 2.4653 124.107 1.48841 124.111 0.508789H121.134L124.065 3.43945Z",
    fill: "#F7F9FA",
    stroke: "#D1DBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.677 24.5557C121.98 23.0434 122.257 21.5238 122.504 19.9961L103.001 0.520508H97.6084L121.677 24.5557Z",
    fill: "#F7F9FA",
    stroke: "#D1DBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8232 79.9746C95.6491 79.0015 96.4598 78.0147 97.2549 77.0137L20.6436 0.512695H15.248L94.8232 79.9746Z",
    fill: "#F7F9FA",
    stroke: "#D1DBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.01 73.4209C100.775 72.3785 101.523 71.3265 102.254 70.2646L32.4062 0.526367H27.0107L100.01 73.4209Z",
    fill: "#F7F9FA",
    stroke: "#D1DBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.162 59.0381C109.79 57.8712 110.403 56.6925 111 55.502L55.9316 0.511719H50.5361L109.162 59.0381Z",
    fill: "#F7F9FA",
    stroke: "#D1DBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.06 51.1982C113.62 49.956 114.164 48.7047 114.693 47.4443L67.6968 0.515625H62.3042L113.06 51.1982Z",
    fill: "#F7F9FA",
    stroke: "#D1DBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.793 66.4365C105.493 65.3347 106.176 64.2224 106.843 63.0996L44.1689 0.511719H38.7734L104.793 66.4365Z",
    fill: "#F7F9FA",
    stroke: "#D1DBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4144 34.9359C25.4144 33.688 25.6606 32.4523 26.1391 31.2995C26.6175 30.1466 27.3188 29.0992 28.2028 28.2171C29.0867 27.3351 30.1362 26.6356 31.291 26.1586C32.4458 25.6817 33.6834 25.4366 34.9331 25.4375H232.488C235.011 25.4375 237.43 26.4382 239.214 28.2195C240.998 30.0008 242 32.4167 242 34.9359V111.375",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1093 148.818L53.625 138.979L65.9156 114.177L72.0608 101.776M74.1093 148.818L89.873 162.191C91.9198 163.928 94.1719 165.406 96.5789 166.593L145.048 190.497C147.985 191.945 151.54 190.808 153.092 187.923C154.712 184.913 153.537 181.159 150.49 179.611L142.732 175.669M74.1093 148.818L98.6904 99.2138L78.2061 89.375H41.4375C32.601 89.375 25.4375 82.2116 25.4375 73.375V34.375M142.732 175.669L129.417 168.905M142.732 175.669L160.633 184.702C163.959 186.381 168.013 184.989 169.61 181.622C171.077 178.53 169.945 174.87 167.088 173.12M153.998 166.753L166.505 172.802C166.706 172.899 166.901 173.006 167.088 173.12M153.998 166.753L135.562 157.837M153.998 166.753L167.088 173.12M167.088 173.12L170.178 174.624C173.458 176.219 177.408 174.846 178.993 171.56C180.575 168.282 179.203 164.342 175.928 162.757L163.216 156.607M163.216 156.607L172.536 161.116C175.477 162.539 179.014 161.333 180.475 158.409C181.958 155.442 180.74 151.834 177.763 150.373L162.272 142.775M163.216 156.607L144.575 147.588M170.386 129.14L166.492 130.053C153.826 133.024 140.975 125.888 136.792 113.562L117.236 120.177C112.008 121.945 106.349 119.062 104.703 113.791L104.19 112.15C103.866 111.112 104.431 110.005 105.462 109.658L149.902 94.7043C155.228 93.0645 161.782 100.717 168.747 98.3939C169.976 97.9839 175.302 96.1403 175.302 96.1403M175.302 96.1403L195.786 89.375L204.799 115.202L209.306 128.115M175.302 96.1403L193.328 147.998L213.812 141.029H226C234.837 141.029 242 148.192 242 157.029V225.656C242 234.493 234.837 241.656 226 241.656H41.4375C32.6009 241.656 25.4375 234.493 25.4375 225.656V118.938",
    stroke: "#6F7C87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1610_35109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementIcon);
export default __webpack_public_path__ + "static/media/agreement-icon.51e6a915.svg";
export { ForwardRef as ReactComponent };